module.exports = __webpack_public_path__ + "img/492-869adf.png";